export const SIGN_OUT_REQUEST = "SIGN_OUT_REQUEST";
export const SIGN_OUT_SUCCESS = "SIGN_OUT_SUCCESS";
export const SIGN_OUT_FAIL = "SIGN_OUT_FAIL";

export const signOut = () => (dispatch: any): any => {
  dispatch({ type: SIGN_OUT_REQUEST });
  sessionStorage.clear();

  dispatch({ type: SIGN_OUT_SUCCESS });
};
